module.exports = __webpack_public_path__ + "static/media/logo.7de6114c.webp";